enum EstablishmentFeeFormatEnum {
    Dollars = 'DOLLARS',
    Percentage = 'PERCENTAGE',
}

export default EstablishmentFeeFormatEnum;
